// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const SaveIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 58 58">
          <path fill="inherit" d="M29 3.61c6.777 0 13.15 2.64 17.942 7.432 4.793 4.793 7.433 11.165 7.433 17.943 0 6.777-2.64 13.15-7.433 17.942C42.15 51.72 35.777 54.36 29 54.36c-6.778 0-13.15-2.64-17.942-7.433-4.793-4.792-7.433-11.165-7.433-17.942 0-6.778 2.64-13.15 7.433-17.943C15.85 6.25 22.222 3.61 29 3.61m0-3.625c-16.016 0-29 12.983-29 29 0 16.016 12.984 29 29 29 16.017 0 29-12.984 29-29s-12.983-29-29-29zm-3.625 41.688a3.628 3.628 0 0 0 2.83-1.36l14.5-18.125a3.626 3.626 0 0 0-5.66-4.53l-11.97 14.963-4.386-4.386a3.625 3.625 0 1 0-5.128 5.127l7.25 7.25a3.623 3.623 0 0 0 2.563 1.063z"/>
        </svg>
      )
    }
  </Icon>
);

export default SaveIcon;
